import axios from "../../interceptors/axiosInterceptor";

import {
    CREATE_ZONAL_CONFIG_URL,
    GET_WAREHOUSE_URL,
    GET_ZONAL_CONFIG_ZONES_URL,
    GET_ZONAL_CONFIG_URL,
    UPDATE_ZONAL_CONFIG_URL,
    GET_ZONAL_CONFIG_TOWNS_URL,
    GET_ZONAL_CONFIG_WAREHOUSE_URL,
    ZONAL_CSV_BOUNDARY_UPLOAD_URL,
    ZONAL_CSV_SERVICE_AREA_UPLOAD_URL,
    GET_ZONAL_CONFIG_WAREHOUSE_STORAGE_BLOCK_URL,
    GET_ZONAL_CONFIG_CHANNEL_URL
} from "../../config/Url";
import {
  ICreateZonalConfigPayload,
  IGetQueryParams,
  IWarehousePayload,
  IZonalConfigUpdatePayload
} from "../../interfaces/Index";
import { getAuthOptions } from "../../config/Headers";
import { normalizeCatchErrors } from "../../utils/errorUtils";
import {
    normalizeFetchZonalConfigResponse,
    normalizeWarehouse,
    normalizeWarehouseName,
    normalizeWarehouseStorageBlockResponse
} from "normalizer/ZonalConfigNormalizer";
import { SOMETHING_WENT_WRONG, UC_TYPE } from "config/constants";
//TODO
export const fetchZonalConfigsApiCall = (
  cityId: string,
  queryParam: IGetQueryParams = {}
) =>
  new Promise((resolve, reject) => {
    const url = GET_ZONAL_CONFIG_URL.replace("{cityId}", cityId);
    let requestConfig: any = getAuthOptions();
    requestConfig.params = queryParam;
    axios
      .get(url, requestConfig)
      .then((response) => {
        if (response) {
          const data = response && response.data;
          const pageNumber: number = queryParam.page
            ? Number(queryParam.page) + 1
            : 1;
          const isPaginatedRes =
            queryParam.page && (queryParam.page as any) > 0 && data.length >= 25
              ? true
              : false;
          resolve(
            normalizeFetchZonalConfigResponse(
              data,
              pageNumber,
              isPaginatedRes
            )
          );
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const createZonalConfigApiCall = (
  payload: ICreateZonalConfigPayload
) =>
  new Promise<void>((resolve, reject) => {
    axios
      .post(CREATE_ZONAL_CONFIG_URL, payload, getAuthOptions())
      .then((response) => {
        if (response) {
          resolve();
        } else {
          reject({ errors: SOMETHING_WENT_WRONG });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

  export const fetchZonalConfigChannelApiCall = (ucId: string) =>
  new Promise<String>((resolve, reject) => {
    const url = GET_ZONAL_CONFIG_CHANNEL_URL.replace("{ucId}", ucId);
    axios
      .get(url, getAuthOptions())
      .then((response) => {
        if (response) {
          resolve(response.data);
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => reject(normalizeCatchErrors(error.response)));
  });

export const updateZonalConfigApiCall = (id: string, zoneType: string, payload: IZonalConfigUpdatePayload) =>
  new Promise<void>((resolve, reject) => {

    let url = UPDATE_ZONAL_CONFIG_URL.replace("{zone_type}/{zone_id}", zoneType + "/" + id);

    axios
      .put(url, payload, getAuthOptions())
      .then((response) => {
        if (response) {
          resolve();
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const fetchZonalConfigWarehouseApiCall = (queryParam: IGetQueryParams = {}) =>
  new Promise<IWarehousePayload[]>((resolve, reject) => {
    let requestConfig: any = getAuthOptions();
    requestConfig.params = queryParam;
    axios
      .get(GET_WAREHOUSE_URL, requestConfig)
      .then((response) => {
        if (response) {
          const data = response && response.data;
          resolve(normalizeWarehouseStorageBlockResponse(data));
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const getZonalConfigChildZonesApiCall = (id: string) =>
  new Promise((resolve, reject) => {
    let url = GET_ZONAL_CONFIG_ZONES_URL.replace("{parentZone_id}", id);
    axios
      .get(url, getAuthOptions())
      .then((response) => {
        if (response) {
          const data = response.data;
          resolve(normalizeWarehouse(data));
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const getZonalConfigTownsApiCall = (id: string) =>
  new Promise((resolve, reject) => {
    let url = GET_ZONAL_CONFIG_TOWNS_URL.replace("{zone_id}", id);
    axios
      .get(url, getAuthOptions())
      .then((response) => {
        if (response) {
          const data = response.data;
          resolve(normalizeWarehouse(data));
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });


//TODO: to be deleted
export const getZonalConfigWarehouseApiCall = (id: string, zoneType: string, zoneStatus: boolean) =>
  new Promise((resolve, reject) => {
    if (zoneType === UC_TYPE && zoneStatus) {
      let url = GET_ZONAL_CONFIG_WAREHOUSE_URL.replace("{zone_id}", id);
      axios
        .get(url, getAuthOptions())
        .then((response) => {
          if (response) {
            const data = response.data;
            resolve(normalizeWarehouseName(data));
          } else {
            reject({ errors: "Something went wrong" });
          }
        })
        .catch((error) => {
          const errorPayload = normalizeCatchErrors(error.response);
          reject(errorPayload);
        });
    }
  });

export const getZonalConfigWarehouseListWithStorageBlocksApiCall = (id: string, zoneType: string) =>

    new Promise((resolve, reject) => {
        if (zoneType === UC_TYPE) {
            let url = GET_ZONAL_CONFIG_WAREHOUSE_STORAGE_BLOCK_URL.replace("{zone_id}", id);
            axios
                .get(url, getAuthOptions())
                .then((response) => {
                    if (response) {
                        const data = response.data;
                        resolve(normalizeWarehouseStorageBlockResponse(data));
                    } else {
                        reject({ errors: "Something went wrong" });
                    }
                })
                .catch((error) => {
                    const errorPayload = normalizeCatchErrors(error.response);
                    reject(errorPayload);
                });
        }
    });

//zone boundary
export const zonalBoundaryCSVMultiPartUploadApiCall = (cityId: string, payload: FormData, url: string) =>
  new Promise<void>((resolve, reject) => {
    let url = ZONAL_CSV_BOUNDARY_UPLOAD_URL.replace("{cityId}", cityId);
    axios
      .post(url, payload, getAuthOptions(true))
      .then((response) => {
        if (response) {
          resolve();
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

//zone service
export const zonalServiceCSVBatchUpdateMultiPartUploadApiCall = (payload: FormData) =>
  new Promise<void>((resolve, reject) => {
    let url = ZONAL_CSV_SERVICE_AREA_UPLOAD_URL;
    axios
      .post(url, payload, getAuthOptions(true))
      .then((response) => {
        if (response) {
          resolve();
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });